export const returnLowestPrice = prices => Math.min(...prices);
